import styles from "./Header.module.css";

function Header() {
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };
    return (
        <header className={styles.header} id="header">
            <h1 className={styles.title}>Осипова Мария · Художник</h1>
            <nav className={styles.nav}>
                <ul className={styles.navBlock}>
                    <li className={styles.navTitles} onClick={() => scrollToSection("about")}>Обо мне</li>
                    <li className={styles.navTitles} onClick={() => scrollToSection("works")}>Мои работы</li>
                    <li className={styles.navTitles} onClick={() => scrollToSection("contacts")}>Контакты</li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;